import type { OpeningListItem } from "~/lib/objects";

export type OpeningGroupListItem = {
  problemSetId: number;
  name: string;
  openingGroupOrder: number;
  hidden: boolean;
};

export type AdminOpeningGroupListItem = OpeningGroupListItem & {
  activeOpeningCount: number;
};

export type OpeningGroupReference = Pick<
  OpeningGroupListItem,
  "problemSetId" | "name"
>;

export type OpeningProblemListScope =
  | { kind: "group"; problemSetId: number }
  | { kind: "current-problem"; problemId: number };

export type OpeningScopedListResponse = {
  group: OpeningGroupReference | null;
  openings: OpeningListItem[];
};

const CANONICAL_POSITIVE_DECIMAL = /^[1-9]\d*$/;

export function parseOpeningGroupIdString(value: string): number | null {
  if (!CANONICAL_POSITIVE_DECIMAL.test(value)) {
    return null;
  }

  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}
